import { ComponentConfig } from "@measured/puck"
import { RenderConfig } from "./RenderConfig"

export type MapDisplayProps = {
  mapHeight?: string
}

export const MapDisplay: ComponentConfig<MapDisplayProps> = {
  // @ts-ignore
  fields: {
    mapHeight: {
      type: "text",
      label: "Map Height",
    },
  },
  defaultProps: {
    mapHeight: "450",
  },
  ...RenderConfig,
}
